import { useMutation } from '@tanstack/react-query'
import { uploadFile, type FileUploadResult } from '@/api/fileUpload'

/**
 * Hook for uploading a file to blob storage via presigned URL
 * Orchestrates: get presigned URL -> upload -> confirm
 */
export function useFileUpload() {
  return useMutation<FileUploadResult, Error, File>({
    mutationFn: uploadFile,
  })
}
